import * as React from "react";
import {
    Typography,
    Box,
    IconButton,
    Grid,
    Skeleton,
    Button,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Chip,
    useMediaQuery,
    useTheme,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Divider,
} from "@mui/material";
import { connect } from "react-redux";
import {
    useNavigate,
    useSearchParams,
} from "react-router-dom";
import {
    main_button,
    MainInput,
} from "../app/components/Styles";
import { Table } from "antd";
import { getProducts, getProductsStatistics, exportProducts, exportProductSales, addProductsMapping } from "../app/store/actions/dataActions";
import { useEffect } from "react";
import { Download, Search, Upload } from "@mui/icons-material";
import CreateTicketModal from "../app/components/CreateTicketModal";
import { formatInt } from "../app/glass/styles";
import SearchFilterBar, { exportIcon } from "../app/glass/SearchFilterBar";
import moment from "moment";
import axios from "axios";
import download from "downloadjs";
import ExcelJS from 'exceljs';
import * as XLSX from 'xlsx';
import ReactFileReader from 'react-file-reader';
import { useTranslation } from 'react-i18next';

export const Products = ({
    getProducts,
    getProductsStatistics,
    exportProducts,
    exportProductSales,
    user,
    addProductsMapping,
    token,
    products,
    topProducts,
    leastProducts,
    totalPieces,
    lowestStocks,
    outOfStockCount,
    isLoading
}) => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [error, setError] = React.useState(null);
    const [isDownloading, setIsDownloading] = React.useState(false);
    const [page, setPage] = React.useState(parseInt(searchParams.get('page')) || 1);
    const [pageSize, setPageSize] = React.useState(parseInt(searchParams.get('pageSize')) || 10);
    const [search, setSearch] = React.useState(searchParams.get('search') || '');
    const [isExportSalesModalOpen, setIsExportSalesModalOpen] = React.useState(false);
    const [isUseBarcodeModalOpen, setIsUseBarcodeModalOpen] = React.useState(false);
    const [startDate, setStartDate] = React.useState(moment().startOf('month'));
    const [endDate, setEndDate] = React.useState(moment().endOf('month'));
    const [file, setFile] = React.useState(null);
    const [productMappings, setProductMappings] = React.useState(null);
    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = React.useState(false);
    const [selectedFilters, setSelectedFilters] = React.useState({});
    const [sortField, setSortField] = React.useState('');
    const [sortOrder, setSortOrder] = React.useState('');
    const [helpTicketOpen, setHelpTicketOpen] = React.useState(false);
    const [helpTicketContext, setHelpTicketContext] = React.useState(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();

    const handleFiles = (files) => {
        setFile(files[0]);
    };

    useEffect(() => {
        var reader = new FileReader();
        if (file) {
            reader.onload = async (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const parsedData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });


                    // Assuming the first row is the header
                    const header = parsedData[0];
                    let items = [];
                    parsedData.slice(1).map((row) => {
                        const item = {};
                        row.forEach((value, index) => {
                            item[header[index]] = value;
                        });

                        if (item["International Barcode"]) {
                            items.push({
                                product: item["Product ID"],
                                internationalBarcode: item["International Barcode"],
                            });
                        }
                    });
                    setProductMappings(items);
                    console.log(items);
                } catch (err) {
                    console.log(err);
                }
            };
            reader.readAsArrayBuffer(file);
        }
    }, [file]);

    useEffect(() => {
        const params = {
            page,
            limit: pageSize,
            ...(search && { search }),
            ...(sortField && sortOrder && { sortOrder: sortOrder === 'ascend' ? '1' : '-1' })
        };
        getProducts(params);
        getProductsStatistics({});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, pageSize, sortField, sortOrder]);

    const handleTableChange = (pagination, filters, sorter) => {
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
        
        // Handle sorting
        if (sorter && sorter.field) {
            setSortField(sorter.field);
            setSortOrder(sorter.order);
        } else {
            setSortField('');
            setSortOrder('');
        }
        
        setSearchParams({
            page: pagination.current.toString(),
            pageSize: pagination.pageSize.toString(),
            ...(search && { search })
        });
    };

    const handleSearch = () => {
        setPage(1);
        const params = {
            page: 1,
            limit: pageSize,
            ...(search && { search }),
            ...(sortField && sortOrder && { sortOrder: sortOrder === 'ascend' ? '1' : '-1' })
        };
        getProducts(params);
        setSearchParams({
            page: '1',
            pageSize: pageSize.toString(),
            ...(search && { search })
        });
    };

    const handleClearSearch = () => {
        setSearch('');
        setSortField('');
        setSortOrder('');
        setPage(1);
        const params = {
            page: 1,
            limit: pageSize
        };
        getProducts(params);
        setSearchParams({
            page: '1',
            pageSize: pageSize.toString()
        });
    };

    const columns = [
        {
            title: t('common.sku'),
            dataIndex: 'externalId',
            key: 'externalId',
        },
        {
            title: t('common.name'),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: t('common.size'),
            dataIndex: 'size',
            key: 'size',
        },
        {
            title: t('common.price'),
            dataIndex: 'price',
            key: 'price',
            render: (_, { price }) => `${price} EGP`
        },
        // {
        //     title: 'In Transfer',
        //     dataIndex: 'inbound',
        //     sorter: (a, b) => a.inbound - b.inbound,
        // },
        {
            title: t('products.available'),
            dataIndex: 'amount',
            key: 'amount',
            sorter: true,
        },
        {
            title: t('products.commited'),
            dataIndex: 'unpackedPieces',
            key: 'unpackedPieces',
        },
        {
            title: t('products.onHand'),
            dataIndex: 'onHand',
            key: 'onHand',
        },
        {
            title: t('products.faulty'),
            dataIndex: 'returns',
            key: 'returns'
        },
        {
            title: t('common.actions'),
            key: 'actions',
            width: 120,
            render: (_, row) => (
                <Button
                    size="small"
                    sx={{ ...main_button, textTransform: "none", py: 0.5, px: 1, fontSize: "0.75rem" }}
                    onClick={() => { setHelpTicketContext({ ticketType: "Product", relevantProduct: row._id }); setHelpTicketOpen(true); }}
                >
                    {t('helpDesk.getHelp')}
                </Button>
            ),
        },
    ];

    const data = products?.docs?.map((row) => {
        return {
            _id: row._id,
            externalId: row.sku || row.externalId,
            image: row.image,
            name: row.name,
            size: row.size,
            color: row.color,
            weight: row.weight,
            price: row.price,
            unpackedPieces: row.unpackedPieces,
            onHand: row.stocks?.reduce((a, b) => a + b.amount, 0) + row.unpackedPieces,
            inbound: row.inbounds?.reduce((a, b) => a + (b.quantity - b.quantityReceived), 0),
            amount: row.stocks?.reduce((a, b) => a + b.amount, 0),
            returns: row.returns?.reduce((a, b) => a + b.amount, 0),
            deletedFromShopify: row.deletedFromShopify,
        }
    })

    const handleExportToExcel = async () => {
        exportProducts({})
    }

    const handleExportSales = () => {
        setIsExportSalesModalOpen(true);
    }

    const handleExportSalesConfirm = () => {
        exportProductSales({
            startDate: startDate.format('YYYY-MM-DD'),
            endDate: endDate.format('YYYY-MM-DD')
        });
        setIsExportSalesModalOpen(false);
    }

    const handleExportSalesCancel = () => {
        setIsExportSalesModalOpen(false);
    }

    const handleUseBarcodeCancel = () => {
        setIsUseBarcodeModalOpen(false);
    }

    const handleUseBarcode = () => {
        setIsUseBarcodeModalOpen(true);
    }

    const handleUseBarcodeConfirm = () => {
        addProductsMapping({ productMaps: productMappings }, navigate);
        setFile(null);
        setProductMappings(null);
        setIsUseBarcodeModalOpen(false);
    }

    const handleDownloadExcel = async () => {
        setIsDownloading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_BASE}/IMPartner/products/simple`, {
            headers: {
                "x-access-token": token
            }
        });
        const products = response.data.products;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Product Mapping');
        workbook.creator = 'Chainz';

        // Submissions by Country
        worksheet.columns = [
            { header: 'Product ID', key: '_id' },
            { header: 'Product SKU', key: 'sku' },
            { header: 'Product Name', key: 'name' },
            { header: 'International Barcode', key: 'internationalBarcode' },
        ];

        products?.forEach((product) => {
            worksheet.addRow({
                "_id": product._id,
                "sku": product.sku || product.externalId,
                "name": product.name,
                "internationalBarcode": product.barcode || ""
            });
        });

        worksheet.autoFilter = {
            from: 'A1',
            to: `D${products?.length + 1}`,
        };

        const buffer = await workbook.xlsx.writeBuffer();
        download(new Blob([buffer]), `product_mapping_${moment().format('YYYY-MM-DD')}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        setIsDownloading(false);
    }

    const mobileColumns = [
        {
            title: t('common.sku'),
            dataIndex: 'externalId',
            key: 'externalId',
        },
        {
            title: t('common.name'),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: t('products.available'),
            dataIndex: 'amount',
            key: 'amount',
            sorter: true,
        },
        {
            title: t('products.commited'),
            dataIndex: 'unpackedPieces',
            key: 'unpackedPieces',
        },
    ];

    const handleFilterChange = (key, value) => {
        setSelectedFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const handleFilterApply = () => {
        const params = {
            page: 1,
            limit: pageSize,
            ...(search && { search }),
            ...selectedFilters,
            ...(sortField && sortOrder && { sortOrder: sortOrder === 'ascend' ? '1' : '-1' })
        };
        getProducts(params);
        setIsFilterDrawerOpen(false);
    };

    const handleFilterReset = () => {
        setSelectedFilters({});
        setSortField('');
        setSortOrder('');
        const params = {
            page: 1,
            limit: pageSize,
            ...(search && { search })
        };
        getProducts(params);
        setIsFilterDrawerOpen(false);
    };

    const oosCount = Number.isFinite(Number(outOfStockCount))
        ? Number(outOfStockCount)
        : (lowestStocks || []).filter((p) => Number(p.amount) < 0).length;
    const topSku = topProducts?.[0]?.sku || '—';
    const lowSku = leastProducts?.[0]?.sku || '—';
    const alertRows = (lowestStocks || []).slice(0, 6);
    const availColor = (n) => (Number(n) < 0 ? '#e2707c' : Number(n) <= 20 ? 'var(--red-tx3)' : 'var(--tx)');
    const chipBtn = {
        border: '1px solid var(--s14)',
        background: 'var(--s03)',
        display: 'flex',
        alignItems: 'center',
        gap: 7,
        cursor: 'pointer',
        fontFamily: 'inherit',
        color: 'inherit',
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div
                className="cz-g2"
                style={{
                    borderRadius: 26,
                    padding: isMobile ? '18px 20px' : '24px 34px',
                    background: 'var(--card-solid)',
                    border: '1px solid var(--s12)',
                    boxShadow: 'inset 0 1px 0 var(--s14), 0 22px 50px var(--sh45)',
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr 1fr',
                    gap: 24,
                    alignItems: 'center',
                }}
            >
                <div>
                    <div style={{ fontSize: 12, color: 'var(--mut2)', marginBottom: 10 }}>{t('products.totalPieces')}</div>
                    <div style={{ fontSize: isMobile ? 28 : 38, fontWeight: 500 }}>{isLoading ? '…' : formatInt(totalPieces)}</div>
                </div>
                <div>
                    <div style={{ fontSize: 12, color: 'var(--mut2)', marginBottom: 10 }}>{t('products.outOfStock')}</div>
                    <div style={{ fontSize: isMobile ? 22 : 30, fontWeight: 500, color: '#e2707c' }}>
                        {isLoading ? '…' : oosCount} <span style={{ fontSize: 15, color: 'var(--tx2)' }}>{t('products.outOfStockSkus')}</span>
                    </div>
                </div>
                <div>
                    <div style={{ fontSize: 12, color: 'var(--mut2)', marginBottom: 10 }}>{t('products.topPerformance')}</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 18, fontWeight: 600 }}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#c0303e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m3 17 6-6 4 4 8-8" />
                            <path d="M14 7h7v7" />
                        </svg>
                        {topSku}
                    </div>
                </div>
                <div style={{ justifySelf: isMobile ? 'start' : 'end', textAlign: isMobile ? 'left' : 'right' }}>
                    <div style={{ fontSize: 12, color: 'var(--mut2)', marginBottom: 10 }}>{t('products.lowPerformance')}</div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: isMobile ? 'flex-start' : 'flex-end', gap: 8, fontSize: 18, fontWeight: 600, color: 'var(--tx2)' }}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--mut)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m3 7 6 6 4-4 8 8" />
                            <path d="M14 17h7v-7" />
                        </svg>
                        {lowSku}
                    </div>
                </div>
            </div>

            <SearchFilterBar
                placeholder={t('products.searchBySkuOrName')}
                value={search}
                onChange={setSearch}
                onSearch={handleSearch}
                isMobile={isMobile}
                extraAdornment={search ? (
                    <IconButton onClick={handleClearSearch} edge="end" sx={{ color: 'var(--tx2)' }}>×</IconButton>
                ) : null}
                actions={(
                    <>
                        <button type="button" className="cz-chip" onClick={handleExportToExcel} disabled={isDownloading || !data?.length}>
                            {t('common.export')}
                            {exportIcon}
                        </button>
                        <button type="button" className="cz-chip" onClick={handleExportSales} disabled={isDownloading}>
                            {t('products.exportSales')}
                            {exportIcon}
                        </button>
                        {!isMobile && (
                            <button type="button" className="cz-chip red" onClick={handleUseBarcode} disabled={isDownloading}>
                                {t('products.useBarcodeDialog')}
                            </button>
                        )}
                    </>
                )}
            />

            <div className="cz-g1" style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 320px', gap: 20, alignItems: 'start' }}>
                <div style={{ minWidth: 0 }}>
                    <Table
                        columns={isMobile ? mobileColumns : columns}
                        dataSource={data}
                        loading={isLoading}
                        rowClassName={(record) => (record?.deletedFromShopify ? 'product-row-shopify-error' : '')}
                        pagination={{
                            current: page,
                            pageSize: pageSize,
                            total: products?.totalDocs,
                            showSizeChanger: false,
                            showQuickJumper: false,
                            showTotal: (total) => `Total ${total} items`,
                        }}
                        onChange={handleTableChange}
                        showSorterTooltip={{ target: 'sorter-icon' }}
                        scroll={{ x: isMobile ? 300 : undefined }}
                    />
                </div>
                <div
                    style={{
                        borderRadius: 24,
                        padding: '22px 24px',
                        background: 'var(--card-solid)',
                        border: '1px solid var(--s10)',
                        boxShadow: 'inset 0 1px 0 var(--s10), 0 18px 44px var(--sh40)',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 16 }}>
                        <div
                            style={{
                                width: 30,
                                height: 30,
                                borderRadius: 10,
                                display: 'grid',
                                placeItems: 'center',
                                background: 'rgba(125,1,12,0.45)',
                                border: '1px solid rgba(190,50,62,0.45)',
                                color: 'var(--red-tx2)',
                            }}
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M12 3 2.5 20h19z" />
                                <path d="M12 10v4" />
                                <path d="M12 17.5v.5" />
                            </svg>
                        </div>
                        <div style={{ fontSize: 15, fontWeight: 600 }}>{t('products.stockAlerts')}</div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                        {isLoading && <Skeleton variant="rounded" animation="wave" height={40} />}
                        {!isLoading && alertRows.length === 0 && (
                            <div style={{ fontSize: 13, color: 'var(--mut)' }}>{t('common.noData')}</div>
                        )}
                        {alertRows.map((product) => {
                            const amt = Number(product.amount);
                            const isOut = amt < 0;
                            return (
                                <div
                                    key={product.sku}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 10,
                                        padding: '10px 12px',
                                        borderRadius: 14,
                                        background: 'var(--s03)',
                                        border: '1px solid var(--s06)',
                                    }}
                                >
                                    <div style={{ fontSize: 13, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis' }}>{product.sku}</div>
                                    <div style={{ marginLeft: 'auto', fontSize: 13, fontWeight: 600, color: availColor(amt) }}>{product.amount}</div>
                                    <div
                                        style={{
                                            fontSize: 10,
                                            padding: '4px 10px',
                                            borderRadius: 999,
                                            background: isOut ? 'rgba(125,1,12,0.45)' : 'rgba(226,112,124,0.18)',
                                            border: `1px solid ${isOut ? 'rgba(190,50,62,0.45)' : 'rgba(226,112,124,0.35)'}`,
                                            color: isOut ? 'var(--red-tx2)' : 'var(--red-tx3)',
                                            fontWeight: 600,
                                        }}
                                    >
                                        {isOut ? t('products.out') : t('products.low')}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <Dialog
                open={isExportSalesModalOpen}
                onClose={handleExportSalesCancel}
                aria-labelledby="export-sales-dialog-title"
                PaperProps={{
                    sx: {
                        backgroundColor: 'var(--modal-bg)',
                        backgroundImage: 'none',
                        color: 'var(--tx)',
                    }
                }}
            >
                <DialogTitle id="export-sales-dialog-title" sx={{ color: 'var(--tx)' }}>
                    {t('products.exportSalesDialog')}
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ color: 'var(--secColor4)', mb: 1 }}>
                        {t('products.exportSalesHint')}
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography sx={{ color: 'var(--secColor4)' }}>{t('common.from')}</Typography>
                                <MainInput
                                    margin="normal"
                                    fullWidth
                                    type="date"
                                    value={startDate.format("YYYY-MM-DD")}
                                    onChange={({ target }) => setStartDate(moment(target.value))}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography sx={{ color: 'var(--secColor4)' }}>{t('common.to')}</Typography>
                                <MainInput
                                    margin="normal"
                                    fullWidth
                                    type="date"
                                    value={endDate.format("YYYY-MM-DD")}
                                    onChange={({ target }) => setEndDate(moment(target.value))}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleExportSalesCancel} sx={{ ...main_button }}>
                        {t('common.cancel')}
                    </Button>
                    <Button onClick={handleExportSalesConfirm} sx={{ ...main_button }}>
                        {t('common.export')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={isUseBarcodeModalOpen}
                onClose={handleUseBarcodeCancel}
                aria-labelledby="use-barcode-dialog-title"
                PaperProps={{
                    sx: {
                        backgroundColor: 'var(--modal-bg)',
                        backgroundImage: 'none',
                        color: 'var(--tx)',
                    }
                }}
            >
                <DialogTitle id="use-barcode-dialog-title" sx={{ color: 'var(--tx)' }}>
                    {t('products.useBarcodeDialog')}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 2 }}>
                        <Typography sx={{ color: 'var(--secColor4)', mt: 1 }}><strong>{t('products.step1')}</strong> {t('products.addBarcodesToExcel')}</Typography>
                        <Button
                            onClick={handleDownloadExcel}
                            sx={{ ...main_button, my: 1 }}
                            disabled={isDownloading}
                            fullWidth
                        >
                            <Download sx={{ color: "var(--secColor4)" }} />
                            {t('common.export')}
                        </Button>
                        <Typography sx={{ color: 'var(--secColor4)', mt: 2 }}><strong>{t('products.step2')}</strong> {t('products.uploadExcelFile')}</Typography>
                        <ReactFileReader handleFiles={handleFiles} fileTypes={[".xlsx", ".xls"]}>
                            <Button fullWidth sx={{ my: 1, ...main_button }}>
                                <Upload /> {t('products.upload')} .xlsx{" "}
                            </Button>
                        </ReactFileReader>
                        {file && <Chip sx={{ backgroundColor: "var(--primaryColor)", color: "var(--secColor4)", mt: 1 }} label={file.name} onDelete={() => setFile(null)} />}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleUseBarcodeCancel} sx={{ ...main_button }}>
                        {t('common.cancel')}
                    </Button>
                    <Button disabled={!file || isLoading || isDownloading} onClick={handleUseBarcodeConfirm} sx={{ ...main_button }}>
                        {t('common.confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
            <CreateTicketModal
                open={helpTicketOpen}
                onClose={() => { setHelpTicketOpen(false); setHelpTicketContext(null); }}
                token={token}
                context={helpTicketContext}
                onSuccess={() => setHelpTicketOpen(false)}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    user: state?.auth?.user,
    isLoading: state?.records?.isLoading || state?.wait?.isLoading,
    token: state?.auth?.token,
    products: state?.records?.products,
    topProducts: state?.records?.topProducts,
    leastProducts: state?.records?.leastProducts,
    totalPieces: state?.records?.totalPieces,
    lowestStocks: state?.records?.lowestStocks,
    outOfStockCount: state?.records?.outOfStockCount,
});

const mapDispatchToProps = { getProducts, getProductsStatistics, exportProducts, exportProductSales, addProductsMapping };

export default connect(mapStateToProps, mapDispatchToProps)(Products);
